import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SessionItemRow, SessionItemsProvider } from '../../providers/sessionItems-provider';
import { EditorService } from '../../services/editor.service';
import { SessionBlocEditComponent } from './session-bloc-edit';
import { EditableBlockInterface } from '../../editable-block-interface';
import { Organization } from "../../../common/models/organization";
import { Exercice } from "../../../common/models/exercice";
import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";
import { SessionExerciceRepeatComponent } from "../session-exercice-repeat/session-exercice-repeat";
import { SessionRestComponent } from "../session-rest/session-rest";
import { SessionExerciceDurationComponent } from "../session-exercice-duration/session-exercice-duration";
import { SessionCommentComponent } from "../session-comment/session-comment";
import { NgForOf, NgIf } from "@angular/common";
import { MatIconButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { MatIcon } from "@angular/material/icon";
import { CdkDrag, CdkDragDrop, CdkDropList } from "@angular/cdk/drag-drop";

@Component({
  selector: 'session-bloc',
  standalone: true,
  providers: [],
  styleUrls: ['./session-bloc.scss'],
  imports: [
    FlexLayoutModule,
    TranslateModule,
    NgIf,
    NgForOf,
    MatIconButton,
    MatTooltip,
    MatMenuItem,
    MatMenuTrigger,
    MatMenu,
    MatIcon,
    CdkDrag,
    CdkDropList,
    SessionExerciceRepeatComponent,
    SessionRestComponent,
    SessionExerciceDurationComponent,
    SessionCommentComponent
  ],
  templateUrl: './session-bloc.html'
})
export class SessionBlocComponent implements EditableBlockInterface {

  public readonly DROPZONES: Map<string, string[]>  = SessionItemsProvider.DROPZONES;
  public readonly EXERCICE_TYPE_REPEAT = Exercice.TYPE_REPEAT;
  public readonly EXERCICE_TYPE_DURATION = Exercice.TYPE_DURATION;
  @Input() public isMobileDisplay = false;
  @Input() public organization: Organization = {} as Organization;
  @Input() public data: SessionItemRow = {} as SessionItemRow;
  @Input() public blocNumber: number | undefined;
  @Input() public itsTheFirst = false;
  @Input() public itsTheLast = false;
  @Input() public isEditable = true;
  @Input() public parentIndex: number | undefined;
  @Input() public selectedStopwatchExerciseIndex: number | undefined
  @Input() public stopwatchSelected: boolean = false;
  @Input() public exerciceDropList: string[] = [];
  @Input() public dropPredicate: (drag: CdkDrag, drop: CdkDropList) => boolean = () => false;

  @Output('onDrop') public onDrop: EventEmitter<CdkDragDrop<SessionItemRow[]>> = new EventEmitter<CdkDragDrop<SessionItemRow[]>>();
  @Output('onTimeBasedInfoUpdated') public onTimeBasedInfoUpdated: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output('onDelete') public onDelete: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
  @Output('onPersonalizedExerciceClicked') public onPersonalizedExerciceClicked: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
  @Output('onDuplicate') public onDuplicate: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
  @Output('onMoveUp') public onMoveUp: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
  @Output('onMoveDown') public onMoveDown: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
  @Output() public onChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output('onDuplicateExerciceAsModel') public onDuplicateExerciceAsModel: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
  @Output() public onValuesAreGood: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
  @Output() public onValuesAreNotGood: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
  @Output() public openStopwatch: EventEmitter<any> = new EventEmitter();
  public isSelected = false;

  constructor(
    private _sessionItemsProvider: SessionItemsProvider,
    public editorService: EditorService
  ) {
  }

  public editComponent(): any {
    return SessionBlocEditComponent;
  }

  public toggleSelected(bool: boolean): void {
    this.isSelected = bool;
  }

  public duplicateExerciceAsModel(toDuplicate: SessionItemRow) {
    this.onDuplicateExerciceAsModel.emit(toDuplicate);
  }

  // public ngAfterContentInit() {
  //     Cette fonction est déclenchée, malgré qu'elle soit "grise" dans l'éditeur. Ce qui posait le problème
  //     lors de la duplication du bloc.
  //     this.setDefaultValues();
  // }

  public duplicateSelf(): void {
    this.onDuplicate.emit(this.data);
  }

  public duplicate(toDuplicate: SessionItemRow): void {
    const duplicate = this._sessionItemsProvider.duplicateSessionItem(toDuplicate);
    this.data.innerElements.splice(duplicate.ord! + 1, 0, duplicate);
    this.onDrop.emit();
  }

  public delete(toDelete: SessionItemRow): void {
    this.onDelete.emit(toDelete);
  }

  public personalize(toPersonalize: SessionItemRow): void {
    this.onPersonalizedExerciceClicked.emit(toPersonalize);
  }

  public onTimeBasedInfoUpdated_child(event: any): void {
    this.onTimeBasedInfoUpdated.emit();
  }

  public onNbRepeatChange(event: EventEmitter<any>): void {
    this.onTimeBasedInfoUpdated.emit();
  }

  public onDropEvent(event: CdkDragDrop<SessionItemRow[]>): void {
    this.data.innerElements.forEach((sessionItem, index) => {
      sessionItem.ord = index;
    });
    this.onDrop.emit(event);
  }

  public moveup(toMove: SessionItemRow, fromChild = true): void {
    toMove.parentIndex = fromChild ? this.parentIndex : undefined;
    this.onMoveUp.emit(toMove);
  }

  public movedown(toMove: SessionItemRow, fromChild = true): void {
    toMove.parentIndex = fromChild ? this.parentIndex : undefined;
    this.onMoveDown.emit(toMove);
  }

  public onDragEvent(v: EventEmitter<any>) {
  }

  // private setDefaultValues(): void {
  //     // if (this.data.id === 0) {
  //     // Si on laisse ceci, le nombre de répétition n'est pas correct si on duplique le bloc.
  //     //     this.data.data.nbRepeat = 1;
  //     // }
  // }
}
